import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
    public Server: string = window.location.protocol + '//' + window.location.host + '/';
    public ApiUrl: string = "api/";
    public ServerWithApiUrl = this.Server + this.ApiUrl;
}


export class AuthConsts {
    public static CLIENT_ID: string = "c5aecf51-0079-47e3-97c7-7ede16b513db";// "ff2599fe-1285-4869-9dbf-7dc1da2ce81c";
    public static TENANT_ID: string = "1840e87d-65f7-48a3-a5ef-cdf3448f8f49"; //"dsentienceiot002.onmicrosoft.com";
    public static GRAPH_RESOURCE: string = "http://ajcbp2systemregistration";// "https://localhost:44384";
}


// WEBPACK FOOTER //
// ./app/app.constants.ts